import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "お部屋", href: "#rooms" },
    { label: "温泉", href: "#onsen" },
    { label: "料金", href: "#pricing" },
    { label: "アクセス", href: "#access" },
    { label: "お問い合わせ", href: "#contact" },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-sm shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 lg:px-12">
        <div className="relative flex items-center justify-between h-16 md:h-20">
          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="メニュー"
          >
            <i
              className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl ${
                scrolled ? "text-stone-900" : "text-white"
              }`}
            />
          </button>

          {/* Desktop left links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.slice(0, 3).map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`text-sm tracking-wider transition-colors duration-300 hover:opacity-70 cursor-pointer ${
                  scrolled ? "text-stone-700" : "text-white/90"
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Center logo - absolutely positioned for true centering */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center cursor-pointer z-10"
          >
            <img
              src="https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/ec3f985d-0f8e-4388-91aa-732955220d2f_logo.png?v=4e906732bd7f67cbda67b434e6bd272b"
              alt="温泉民宿宝栄丸"
              className="h-8 md:h-10 w-auto object-contain"
            />
          </a>

          {/* Desktop right links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.slice(3).map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`text-sm tracking-wider transition-colors duration-300 hover:opacity-70 cursor-pointer ${
                  scrolled ? "text-stone-700" : "text-white/90"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:0557-95-1813"
              className="hidden lg:inline-flex items-center gap-2 px-5 py-2 bg-warm-700 text-white text-sm rounded-full hover:bg-warm-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line" />
              ご予約
            </a>
          </div>

          {/* Mobile phone button */}
          <a
            href="tel:0557-95-1813"
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="電話予約"
          >
            <i
              className={`ri-phone-line text-xl ${
                scrolled ? "text-stone-900" : "text-white"
              }`}
            />
          </a>
        </div>
      </nav>

      {/* Mobile menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-stone-100 transition-all duration-300 overflow-hidden ${
          mobileOpen ? "max-h-[420px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 py-3 space-y-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="block py-3.5 px-3 text-sm tracking-wider text-stone-800 hover:bg-warm-50 rounded-lg transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:0557-95-1813"
            className="flex items-center justify-center gap-2 w-full mt-3 py-3.5 bg-warm-700 text-white text-sm rounded-full cursor-pointer"
          >
            <i className="ri-phone-line" />
            電話でご予約 0557-95-1813
          </a>
        </div>
      </div>
    </header>
  );
}